import { useQuery } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { NotesListQuery } from '@rossum/api-client/notes';
import { api } from '../../../../lib/apiClient';

export const GET_COMMENTS_QUERY_KEY = 'get-comments';

export const useGetComments = ({ annotation }: NotesListQuery) => {
  return useQuery({
    queryKey: [GET_COMMENTS_QUERY_KEY, annotation],
    queryFn: () => {
      if (!annotation) throw new Error('Annotation id is undefined');
      return api.request(
        endpoints.notes.list({ annotation, ordering: '-created_at' })
      );
    },
    enabled: !!annotation,
    select: response => response.results,
    keepPreviousData: true,
  });
};
